import React, { useRef, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

import { MainContainer, Header } from '../../components';
import { Hero } from './components';
import { Wrapper, ContentGrid } from './styles';
import getConfigs from './config';

const MainLayout = ({ children }) => {

  const layoutRef = useRef(null);
  const { pathname } = useLocation();
  const { heroProps, headerProps } = getConfigs(pathname);
  const [scrollPosition, setScrollPosition] = useState(0);

  useEffect(() => {
    layoutRef.current.scrollTop = 0;
  }, [pathname]);

  useEffect(() => {
    const handleScroll = () => setScrollPosition(layoutRef.current.scrollTop);
    layoutRef.current.addEventListener('scroll', handleScroll);
    return () => {
      layoutRef.current.removeEventListener('scroll', handleScroll);
    }
  }, []);

  return (
    <Wrapper ref={ layoutRef } className='Wrapper' heroShow={ heroProps?.show }>

      <Hero scrollPosition={ scrollPosition } {...heroProps} />

      <ContentGrid>
        <MainContainer overlayHeaderMobile={ headerProps.overlayHeaderMobile } >
          <Header {...headerProps} />
          { children }
        </MainContainer>
      </ContentGrid>

    </Wrapper>
  );
};

MainLayout.propTypes = {
  children: PropTypes.any,
};

export default MainLayout;